import { showToastMessage } from './ShowToastMessage'

// Use as generic error message to show users when the error they encounter
// is something they have no control over and we need to fix on our end.
export const showInternalServerErrorMessage = () =>
  showToastMessage('Yikes! Something went wrong on our side. Contact support@blaze.ai for help.', 'error')
